import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Button,
  Label
} from "reactstrap";
import {
  Link
} from "react-router-dom";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import Select from "react-dropdown-select";
import { toast } from 'react-toastify';
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay'
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Scrollbars } from 'react-custom-scrollbars';
import VirtualMachineTypeService from '../../services/api/VirtualMachineType';
import Switch from "react-bootstrap-switch";
import ProvisionerService from '../../services/api/Provisioner'; 
import { vmServiceName } from '../../settings/shared/constants';



const styles = {
  errorBox: {
    textAlign: "center",
    marginBottom: 20
  },
  error: {
    color: "rgb(255, 0, 0)",
    fontSize: 13,
    backgroundColor: "rgb(249, 228, 228)",
    padding: "6px 200px 6px 250px",
    borderRadius: 6
  },
  passwordHint: {
    color: "#000",
    fontSize: 12
  }
}
const float_regex = /^[+-]?\d*(?:[.,]\d*)?$/;

class newmachinetype extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      errorSubmitted: false,
      mode: '',
      name: '',
      description: '',
      provisionerName:"",
      provisionerId:"",
      instanceType:"",
      location:'', 
      vCPUs:'',
      memory:'',  
      enableVM:true,
      serviceStatus:'',
      vpcId:'',
      subnetId:'',
      errorMessage: '',
      editId: "",
      lockstatus: false,
      editFlag: false,
      swidth: window.innerWidth,
      sheight: window.innerHeight,
      cloudOptions: [],
      cloudType: "",
      ctype: '',
      instanceOptions: [],
      regionOptions: [],
      provisionerOptions: [],
      Pd:[],
      provisionerType: ''
      
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    let mode = this.props.location.state.mode;
    this.getProvisionerOption()
    if (mode === "editMachineType") {
      let editData = this.props.location.state.EditData
      this.editMachineType(editData);
     } 
     else {
      this.setState({
         btnActions: "Create",
         cloudType: ""
       });
     }
    // this.getProvisionerOption( function(thisObject){
    //   if (mode === "editMachineType") {
    //     let editData = thisObject.props.location.state.EditData
    //     thisObject.EditMachineType(editData);
    //    }
    //    else {
    //     thisObject.setState({
    //        btnActions: "Create",
    //        cloudType: ""
    //      });
    //    }
    // })
    
  // this.getCloudOption();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight });
  }
  getProvisionerOption = () => {
    ProvisionerService.getProvisionerByService(vmServiceName)
      .then((response) => {
        let options = [];
        let ProvisionerData = response.provisionerDTOPage.content;
        // console.log('ProvisionerData',ProvisionerData)
        this.setState({provisionerRecords:response.provisionerDTOPage.content})
        this.state.Pd = response.provisionerDTOPage.content;
        if (ProvisionerData.length !== 0) {
          options = ProvisionerData.map((item,index) => {
            return (
              { label:item.name, value: item.name ,id: item.id, provisionerType: item.provisionerType}
            )
          })
          this.setState({
            provisionerOptions: options,
            loading: false,
          })

          // let mode = this.props.location.state.mode;
          // if (mode === "editMachineType") {
          //   this.getProvisionerNameById(this.state.provisionerRecords,this.state.provisionerRecords[0].id)
          //  } 
        }

      }).catch((error) => {
        this.setState({ loading: false });
      })

  }

  getProvisionerNameById(provisioners,id) {
    let provisionerName =[];
    if(provisioners !== undefined) {
     provisionerName = provisioners.map((item,index) => {
          if(item.id === id)
          {
            this.setState({
              provisionerName:item.name,
              loading: false,
            })
          }
      })
    }
  }
  
  handleSwitch(elem, state) {
    this.setState({enableVM:state})
  }
  // Edit MachineType
  editMachineType(data) {
    if(data !== null && data !== undefined) {
    this.setState({
      loading: true,
      btnActions: "Update",
      editId: data.id,
    });

    ProvisionerService.getProvisionerByService(vmServiceName)
    .then((response) => {
      this.setState({
        provisionerRecordss:response.provisionerDTOPage.content,
        loading: false,
      })
   
  this.getProvisionerNameById(this.state.provisionerRecordss,data.provisionerId)
  this.setState({
    name: data.name,
    description: data.description,
    instanceType: data.instanceType,
    provisionerName: this.state.provisionerName,
    provisionerId:data.provisionerId,
    location: data.location,
    vCPUs:data.vCPUs,
    memory:data.memory,  
    serviceStatus: data.serviceStatus,
    vpcId: data.vpcId,
    subnetId: data.subnetId

})
});
  if(data.serviceStatus === 'ENABLED'){
    this.setState({enableVM:true})
    this.state.enableVM = true;
  }
  else{
    this.setState({enableVM:false})
    this.state.enableVM = false;
  }
}
  }

  setErrorMessage(message) {
    if (message == "") {
      this.setState({
        errorMessage: message,
        errorSubmitted: false
      })
    } else {
      document.getElementById('errorDiv').scrollIntoView()
      this.setState({
        errorMessage: message,
        errorSubmitted: true
      });
    }
  }
  // Submit New Connection Data
  CreateNewInstance = (event) => {
    event.preventDefault();
  
    if ((this.state.name == "" || this.state.name == undefined)) {
      this.setErrorMessage("Please Enter Name");
    }
    else if (this.state.provisionerName == "") {
      this.setErrorMessage("Please Select Provisioner Name");
    }
    else if (this.state.location == "") {
      this.setErrorMessage("Please Enter location");
    }
    else if (this.state.instanceType == "") {
      this.setErrorMessage("Please Enter Machine Type");
    } 
    else if (this.state.vCPUs == "") {
      this.setErrorMessage("Please Enter vCPUs");
    }
    else if (this.state.memory == "") {
      this.setErrorMessage("Please Enter memory");
    }
    else {
      if (this.state.editId !== "") {
        this.UpdateInstanceType();
      } else {
        this.PostInstanceType();
      }
    }
  }
  PostInstanceType = () => {
    this.setErrorMessage("");
    if (!this.state.errorSubmitted) {
      let post = {}
      if(this.state.enableVM === true){
        this.setState({serviceStatus:'ENABLED'})
        this.state.serviceStatus = 'ENABLED';
      }
      else{
        this.setState({serviceStatus:'DISABLED'})
        this.state.serviceStatus = 'DISABLED';
      }
      post = {
        active: true,
        name: this.state.name,
        description: this.state.description,
        instanceType: this.state.instanceType,
        provisionerName: this.state.provisionerName,
        provisionerId: this.state.provisionerId,
        location: this.state.location,
        vCPUs:this.state.vCPUs,
        memory:this.state.memory,  
        platformDefault:true,
        serviceStatus: this.state.serviceStatus,
        vpcId: this.state.vpcId,
        subnetId: this.state.subnetId
      }
      VirtualMachineTypeService.postVMType(post)
        .then((response) => {
          if (response.status === 'SUCCESS') {
            toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Instance Type Created Successfully!</b></i>); 
            this.props.history.push('/cloud/machinetype/');
          } else {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
          }
        }
        );
    } else {
      console.error('Invalid Form')
    }
  }
  UpdateInstanceType = () => {
    this.setErrorMessage("");
    if (!this.state.errorSubmitted) {
      let post = {}
      if(this.state.enableVM === true){
        this.setState({serviceStatus:'ENABLED'})
        this.state.serviceStatus = 'ENABLED';
      }
      else{
        this.setState({serviceStatus:'DISABLED'})
        this.state.serviceStatus = 'DISABLED';
      }
      post = {
        active: true,
        name: this.state.name,
        description: this.state.description,
        instanceType: this.state.instanceType,
        provisionerName: this.state.provisionerName,
        provisionerId: this.state.provisionerId,
        location: this.state.location,
        vCPUs:this.state.vCPUs,
        memory:this.state.memory,  
        platformDefault:true,
        serviceStatus: this.state.serviceStatus,
        vpcId: this.state.vpcId,
        subnetId: this.state.subnetId
      }
      VirtualMachineTypeService.updateVMType(post, this.state.editId)
        .then((response) => {
          if (response.status === 'SUCCESS') {
            toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Machine Type Updated Successfully!</b></i>); 
            this.props.history.push('/cloud/machinetype/');
          } else {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
          }
        }
        );
    } else {
      console.error('Invalid Form')
    }
  }
  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  handleChangevCPUs = (event) => {
    if (float_regex.test(event.target.value))
        this.setState({ vCPUs : event.target.value });
 }
  
 handleChangeMemory = (event) => {
  if (float_regex.test(event.target.value))
      this.setState({ memory : event.target.value });
}

handleChangeVpcID = (event) => {
  if (event !==  undefined && event !== null) {
  this.setState({
    vpcId: event.target.value
  })
}
} 

handleChangeSubnetId = (event) => {
  if (event !==  undefined && event !== null) {
  this.setState({
    subnetId: event.target.value
  })
}
} 

  handleChangeProvisionerType = (event) =>{
    if (event.length > 0) {
    this.setState({
      provisionerName:event[0].value,
      provisionerId:event[0].id,
      provisionerType: event[0].provisionerType
    })
  }
  }
//   handleChangecloudType = (event) => {
//  this.setState({
//       cloudType: event[0].value
//     });
//  let lowercasecloudType =  event[0].value.toLowerCase()
//       InstanceTypeService.getRegionAndInstanceType(lowercasecloudType)
//         .then((response) => {
//           let instanceData = response.instanceTypeDTO;
//           let RegionData = response.instanceTypeAliasRegionDTO;
//          if (instanceData.length !== 0) {
//             let instTypes = instanceData
//             const instancearray = instTypes.map((item, index) => {
//               return (
//                 { label: <div><b>{item.instanceType} </b><code><b>vCPUs- </b></code><b>{item.vcPUs}</b> <code><b>Memory- </b></code><b>{item.memoryGiB}</b></div>, value: item.instanceType }
//               )
//             })
//             this.setState({
//               instanceOptions: instancearray,
//               loading: false,
//             })
//           }
//           if (RegionData.length !== 0) {
//             let regionTypes = RegionData
//             const regionarray = regionTypes.map((item, index) => {
//               return (
//                 { label: <div><b>{item.region}</b></div>, value: item.region }
//               )
//             })
//             this.setState({
//               regionOptions: regionarray,
//               loading: false,
  
//             })
//           }
//         }).catch((error) => {
//           this.setState({ loading: false });
//         })   
//   }
  handleChangeregionName = (event) => {
if(event.length > 0){
    this.setState({
      regionName: event[0].value,
    });
  }
  }
  handleChangeinstanceType = (event) => {
    if(event.length > 0){
    this.setState({
      instanceType: event[0].value,
    });
  }
  }
  cancelClick = () => {
    this.props.history.push('/cloud/machinetype/');
  }
  render() {
    const { errors } = this.state;
    return (

      <>
        <PanelHeader
          content={
            <div className="header text-center">

            </div>
          }
        />
        <div className="content">
          <LoadingOverlay
            active={this.state.loading}
            spinner={<ScaleLoader
              height={35}
              width={5}
              radius={2}
              margin={2}
              color={"#123abc"}
              loading={this.state.loading}
            />}
          >
            <Col xs={12} md={12}>
              <Row>
                <div className=" col" id="errorDiv">
                  <Card className=" shadow">
                    <CardHeader className=" bg-transparent">
                      <Row className="align-items-center">
                        <div className="col">
                          {this.state.editId !== "" && <h5 className="mb-0">Update Instance Type</h5>}
                          {this.state.editId === "" && <h5 className="mb-0">New Instance Type</h5>}
                        </div>
                        <div className="col text-right">
                          <Link to="machinetype" >
                            <span className="close clear-filter">×</span>
                          </Link>

                        </div>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      <div className="carcontent">
                        <Scrollbars autoHeight autoHeightMin={this.state.sheight - 200}>

                          {this.state.errorSubmitted &&
                            <div style={styles.errorBox}>
                              <span style={styles.error}>{this.state.errorMessage}</span>
                            </div>
                          }
                          <Form onSubmit={this.CreateNewInstance} noValidate>
                            <div className="pl-lg-4">
                              <Row>
                                <Col lg="6">
                                  <FormGroup>
                                    <label
                                      className="form-control-label"
                                      htmlFor="input-email"
                                    >
                                      Name
                            </label>
                                    <Input
                                      className="form-control"
                                      placeholder="Name"
                                      name="name"
                                      value={this.state.name}
                                      type="text"
                                      onChange={this.handleChange} />
                                  </FormGroup>
                                </Col>
                                <Col lg="6">
                                  <FormGroup>
                                    <label
                                      className="form-control-label"
                                      htmlFor="input-email"
                                    >
                                      Description
                            </label>
                                    <Input
                                      className="form-control"
                                      placeholder="Description"
                                      name="description"
                                      value={this.state.description}
                                      type="text"
                                      onChange={this.handleChange} />
                                  </FormGroup>
                                </Col>
                              </Row>

                              <Row>
                                <Col lg="12">
                                  <FormGroup>
                                    <label
                                      className="form-control-label"
                                      htmlFor="input-username"
                                    >
                                      Provisioner
                                    </label>
                                    <Select name="provisionerName" className="form-control"
                                      values={this.state.provisionerOptions.filter(item => item.value === this.state.provisionerName)}
                                      id={this.state.provisionerOptions.filter(item => item.id === this.state.provisionerId)}
                                      options={this.state.provisionerOptions}
                                      onChange={(e) => { this.handleChangeProvisionerType(e) }}
                                      noValidate></Select>
                                  </FormGroup>

                                </Col>
                              </Row>
                              <Row>
                              <Col lg="6">
                                  <FormGroup>
                                    <label
                                      className="form-control-label"
                                      htmlFor="input-email"
                                    >
                                      Machine Type 
                                    </label>
                                    <Input className="form-control" placeholder="Instance Type" name="instanceType" value={this.state.instanceType} type="text"
                                      onChange={this.handleChange} />
                                  </FormGroup>
                                </Col>
                                <Col lg="6">
                                  <FormGroup>
                                    <label
                                      className="form-control-label"
                                      htmlFor="input-username"
                                    >
                                      Location
                                    </label>
                                    <Input className="form-control" placeholder="location" name="location" value={this.state.location} type="text"
                                      onChange={this.handleChange} />
                                  </FormGroup>

                                </Col>
                              </Row>
                              <Row>
                              <Col lg="6">
                                  <FormGroup>
                                    <label
                                      className="form-control-label"
                                      htmlFor="input-email"
                                    >
                                      vCPUs
                                    </label>
                                    <Input className="form-control" placeholder="vCPUs" name="vCPUs" value={this.state.vCPUs} type="text" maxLength={9}
                                    pattern="/^[+-]?\d+(?:[.,]\d+)?$/" onChange={this.handleChangevCPUs} />
                                  </FormGroup>
                                </Col>
                                <Col lg="6">
                                  <FormGroup>
                                    <label
                                      className="form-control-label"
                                      htmlFor="input-username"
                                    >
                                      Memory
                                    </label>
                                    <Input className="form-control" placeholder="memory" name="memory" value={this.state.memory} type="text" pattern="/^[+-]?\d+(?:[.,]\d+)?$/"
                                      onChange={this.handleChangeMemory} />
                                  </FormGroup>

                                </Col>
                                <Col>
                                  {
                                    this.state.provisionerType === "AWS" &&
                                    <FormGroup>
                                      <label
                                        className="form-control-label"
                                        htmlFor="input-username"
                                      >
                                        VPC Id
                                      </label>
                                      <Input className="form-control" placeholder="VPC ID" name="vpcid" value={this.state.vpcId} type="text"
                                        onChange={this.handleChangeVpcID} />
                                    </FormGroup>
                                  }
                                </Col>
                                <Col>
                                  {
                                    this.state.provisionerType === "AWS" &&
                                    <FormGroup>
                                      <label
                                        className="form-control-label"
                                        htmlFor="input-username"
                                      >
                                        Subnet Id
                                      </label>
                                      <Input className="form-control" placeholder="Subnet Id" name="vpcid" value={this.state.subnetId} type="text"
                                        onChange={this.handleChangeSubnetId} />
                                    </FormGroup>
                                  }
                                </Col>
                              </Row>
                              <br></br>
                              <Row >
                      <Col md="6">
                      <FormGroup >
                          <Label>Enable Virtual Machine </Label>&nbsp; &nbsp;&nbsp; &nbsp;<Switch onChange={(el, state) => this.handleSwitch(el, state)} value={this.state.enableVM} name='write access' data-on-color="secondary" data-off-color="default"/>

                          </FormGroup>
                          </Col>
                    
                      </Row>
                            </div>
                            <hr className="my-4" />

                            {this.state.editFlag && <Row className="stickybuttons">
                              <Col lg="1">

                                <FormGroup>
                                  <br></br>
                                  <br></br>
                                  <Button
                                    color="primary"
                                    size="sm"
                                    onClick={e => this.UpdateAccount()}
                                  >
                                    Update
                     </Button>
                                </FormGroup>
                              </Col>
                              <Col lg="1">

                                <FormGroup>
                                  <br></br>
                                  <br></br>
                                  <Button
                                    color="primary"
                                    onClick={e => this.DeleceAccount()}
                                    size="sm"
                                  >
                                    Delete
                     </Button>
                                </FormGroup>
                              </Col>
                              <Col lg="2">
                                <FormGroup>
                                  <br></br>
                                  <br></br>
                                  {this.state.editFlag && <Button
                                    color="primary"
                                    onClick={e => this.LockUnlockUser()}
                                    size="sm"
                                  >
                                    {this.state.lockstatus ? "Temporary Lock" : "Unlock"}
                                  </Button>}
                                </FormGroup>
                              </Col>
                            </Row>}


                            <Row>
                              <Col lg="1">
                                <FormGroup>
                                  <Button
                                    color="secondary"
                                    size="sm"
                                    type="submit"
                                    onClick={this.cancelClick}
                                  >
                                    Cancel
                     </Button>
                                </FormGroup>
                              </Col>
                              <Col lg="2">
                                <FormGroup>
                                  <Button
                                    color="primary"
                                    size="sm"
                                    type="submit"
                                    onClick={this.CreateNewInstance}
                                  >
                                    {this.state.btnActions}
                                  </Button>
                                </FormGroup>
                              </Col>
                            </Row>
                          </Form>
                        </Scrollbars>

                      </div>
                    </CardBody>
                  </Card>
                </div>
              </Row>
            </Col>
          </LoadingOverlay>

        </div>
      </>
    );
  }
}

export default newmachinetype;
